import {
  getAll,
  getSystemModuleNames,
} from '@/api/permissionserv'

export default {
  state: {
    state_Permission_GetAllResult: null,
    state_Permission_GetSystemModuleNamesResult: null,
  },
  mutations: {
    SET_PERMISSION_GETALL_RESULT: (state, rst) => {
      state.state_Permission_GetAllResult = rst;
    },
    SET_PERMISSION_GETSYSTEMMODULENAMES_RESULT: (state, rst) => {
      state.state_Permission_GetSystemModuleNamesResult = rst;
    },
  },
  actions: {
    PermissionServ_GetAll({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getAll(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_PERMISSION_GETALL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_PERMISSION_GETALL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    PermissionServ_GetSystemModuleNames({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getSystemModuleNames(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_PERMISSION_GETSYSTEMMODULENAMES_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_PERMISSION_GETSYSTEMMODULENAMES_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_Permission_GetAllResult: state => {
      return state.state_Permission_GetAllResult;
    },
    get_Permission_GetSystemModuleNamesResult: state => {
      return state.state_Permission_GetSystemModuleNamesResult;
    },
  }
}